import { render, staticRenderFns } from "./YesNoDashboardItem.vue?vue&type=template&id=1a6f3d59&scoped=true"
import script from "./YesNoDashboardItem.vue?vue&type=script&lang=js"
export * from "./YesNoDashboardItem.vue?vue&type=script&lang=js"
import style0 from "./YesNoDashboardItem.vue?vue&type=style&index=0&id=1a6f3d59&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6f3d59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a6f3d59')) {
      api.createRecord('1a6f3d59', component.options)
    } else {
      api.reload('1a6f3d59', component.options)
    }
    module.hot.accept("./YesNoDashboardItem.vue?vue&type=template&id=1a6f3d59&scoped=true", function () {
      api.rerender('1a6f3d59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/YesNoDashboardItem.vue"
export default component.exports